module.exports = __webpack_public_path__ + "static/media/mobile_team_2x.ce8784cb.png";